import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import VaContinueLoginImage from "@/icons/continue-login-image";
import { ContinueLoginBox, ContinueLoginImage, PasswordMessage, PasswordSuccessMessage } from "./continue-login-style";
const ContinueLogin = (props) => {
    const { setVisible, setUiState = () => { }, setFormData = () => { }, initialFormData = {}, signup = false, emailVerified = false, } = props;
    const navigate = useNavigate();
    return (_jsxs(ContinueLoginBox, { children: [_jsx(ContinueLoginImage, { children: _jsx(VaContinueLoginImage, {}) }), emailVerified ? (_jsx(PasswordMessage, { children: "Email Verified" })) : (_jsx(PasswordMessage, { children: signup ? "Signup successful" : "Password Changed" })), emailVerified ? (_jsx(PasswordSuccessMessage, { children: "Your email has been verified successfully" })) : (_jsx(PasswordSuccessMessage, { children: signup ? "You have Signed up successfully" : "Your password has been changed successfully" })), _jsx("div", { className: "grid", children: _jsx(Button, { id: "continue-login", "data-testid": "sign-up", variant: "contained", fullWidth: true, sx: { borderRadius: "10px", backgroundColor: '#2a19d2' }, onClick: () => {
                        if (!signup) {
                            if (!emailVerified) {
                                setFormData(initialFormData);
                                setUiState("email-only");
                            }
                        }
                        else {
                            navigate("/login");
                            setVisible(false);
                        }
                        setVisible(false);
                    }, children: "Continue Login" }) })] }));
};
export default ContinueLogin;
